import React from 'react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

const StatCard = ({ title, value, icon: Icon, color, urgent }) => (
  <Card className={cn("relative overflow-hidden", urgent && "border-red-300 bg-red-50")}>
    <CardContent className="p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-slate-500">{title}</p>
          <p className={cn("text-3xl font-bold", urgent ? "text-red-600" : "text-slate-900")}>{value}</p>
        </div>
        <div className={cn("p-3 rounded-full", color)}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
      {urgent && value > 0 && (
        <div className="absolute top-2 right-2">
          <span className="flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
          </span>
        </div>
      )}
    </CardContent>
  </Card>
);

export { StatCard };
export default StatCard;
